import { Suspense, useEffect, useRef } from 'react'
import Analytics from 'lib/analytics'
import { isClient, isDev } from 'util/env'
import { convertVersionToInt } from 'util/version'
import OneSignal from 'react-onesignal'
import { FacebookPixelEvents } from 'ui/shared/FacebookPixelEvents'

const AppInit = () => {
  const oneSignalInitialized = useRef(false)
  useEffect(() => {
    if (isClient()) {
      Analytics.init()

      Analytics.setSuperProps({
        appVersion: process.env.APP_VERSION || 'unknown',
        appVersionCode:
          convertVersionToInt(process.env.APP_VERSION) || 'unknown',
      })

      if (!oneSignalInitialized.current) {
        oneSignalInitialized.current = true
        OneSignal.init({
          appId: process.env.ONE_SIGNAL_APP_ID!,
          allowLocalhostAsSecureOrigin: isDev(),
          autoRegister: false,
        })
      }
    }
  }, [])

  return (
    <>
      <Suspense fallback={null}>
        <FacebookPixelEvents />
      </Suspense>
    </>
  )
}

// Make the install app event available to other components
// https://developer.mozilla.org/en-US/docs/Web/API/BeforeInstallPromptEvent
export let installEvent: BeforeInstallPromptEvent | null = null
if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    const event = e as BeforeInstallPromptEvent
    e.preventDefault()
    installEvent = event
  })
}

export default AppInit
